import React from 'react'
import { Box, Button } from '@mui/material'

import GoogleIcon from '../../../../components/icon/GoogleIcon'
import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_ACCENT_ORANGE_ALT_HOVER,
  UI_COLOR_WHITE
} from '../../../../constants/uiColors'
import { REFUND_APPROVAL_TEXT } from '../../../constants/refundApprovalText'

const getNcrButtonSx = ({ fullWidthOnMobile = false } = {}) => ({
  alignSelf: fullWidthOnMobile ? 'stretch' : 'flex-start',
  width: fullWidthOnMobile ? '100%' : 'auto',
  height: fullWidthOnMobile ? 44 : 37,
  minHeight: fullWidthOnMobile ? 44 : 36,
  px: fullWidthOnMobile ? 1 : 2,
  bgcolor: UI_COLOR_ACCENT_ORANGE,
  color: UI_COLOR_WHITE,
  fontSize: fullWidthOnMobile ? 13 : 14,
  fontWeight: 500,
  lineHeight: 1,
  textTransform: 'uppercase',
  boxShadow: 'none',
  '& .MuiButton-startIcon': {
    ml: 0,
    mr: fullWidthOnMobile ? 0.75 : 1
  },
  '&:hover': {
    bgcolor: UI_COLOR_ACCENT_ORANGE_ALT_HOVER,
    boxShadow: 'none'
  },
  '&.Mui-disabled': {
    color: UI_COLOR_WHITE
  }
})

const RefundNcrActionButton = ({ fullWidthOnMobile = false, loading = false, onClick }) => (
  <Button
    variant="contained"
    startIcon={
      <Box component="span" aria-hidden="true" sx={{ display: 'inline-flex' }}>
        <GoogleIcon name="assignment_add" size={16} color={UI_COLOR_WHITE} />
      </Box>
    }
    onClick={onClick}
    disabled={loading}
    disableElevation
    sx={getNcrButtonSx({ fullWidthOnMobile })}
  >
    {REFUND_APPROVAL_TEXT.registerNcr}
  </Button>
)

export default RefundNcrActionButton
